import { useCallback, useEffect, useRef, useState } from 'react';

import { InteractionManager } from 'react-native';

import { useSelector } from 'react-redux';

import { useFocusEffect } from '@react-navigation/native';

import { selectPlayerConfig } from 'store/player/selectors';

import useNoInternetAlertVisible from 'components/NoInternetAlert/hooks/useNoInternetAlertVisible';

import useCloseModalPlayer from './useCloseModalPlayer';

function useCloseModalPlayerOnDetailsPage() {
    const { visible } = useSelector(selectPlayerConfig);
    const { visible: isNoInternetAlertVisible } =
        useNoInternetAlertVisible(false);

    const onCloseModalPlayer = useCloseModalPlayer();

    const [focused, setFocused] = useState(false);
    const prevFocused = useRef(focused);
    const prevIsNoInternetAlertVisible = useRef(isNoInternetAlertVisible);

    useFocusEffect(
        useCallback(() => {
            setFocused(true);

            return () => {
                setFocused(false);
            };
        }, []),
    );

    useEffect(() => {
        let task:
            | undefined
            | ReturnType<typeof InteractionManager.runAfterInteractions>;

        if (
            !prevFocused.current &&
            focused &&
            visible &&
            !isNoInternetAlertVisible &&
            prevIsNoInternetAlertVisible.current
        ) {
            task = InteractionManager.runAfterInteractions(onCloseModalPlayer);
        }

        prevFocused.current = focused;

        return () => {
            task?.cancel();
        };
    }, [focused, visible, onCloseModalPlayer, isNoInternetAlertVisible]);
}

export default useCloseModalPlayerOnDetailsPage;
